<template>
    <div>
        <el-button class="excel_btn" @click="downloadExcel()">엑셀 다운로드</el-button>
    </div>
</template>

<script>
import {setExcelConfig, runExcelDown} from "@/mixins/excelApiDown";
import listMixins from "@/mixins/listMixins";

export default {
    name: "ExcelComponent",
    mixins: [listMixins],
    components: {},
    inject: [],
    provide() {
        return {}
    },
    props: {
        filterData: {}
    },
    data() {
        return {}
    },
    beforeRouterEnter() {
    },
    created() {
    },
    mounted() {

    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {},
    methods: {
        downloadExcel() {
            let listOptions = {
                url: this.$api,
                defaultParams: {},
            }
            this.initList('api', listOptions);
            let filterObj = {
                page: {},
                filter: this.filterData,
                sort: {},
            }
            let params =  this.listClass.makeParams(filterObj);

            if (this.$route.name === 'MemberList') {
                setExcelConfig(`member/download`, '회원리스트')
                params.mt = 'student'
            } else if (this.$route.name === 'MemberQuit') {
                setExcelConfig(`member/download`, '탈퇴회원리스트')
                params.mt = 'out'
            } else if (this.$route.name === 'MemberPremium') {
                setExcelConfig(`member/premium/excel`, '프리미엄회원리스트')
            }
            runExcelDown(params);
        },
    },
    watch: {},
}
</script>

<style scoped>

</style>
